<template>
    <div>
        <base-header  type="gradient-success" class="pb-3 pb-3 pt-5 pt-md-8">
                    
            
            
        </base-header>

        
            

                
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Mon Compte</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <a href="#!" style="background-color:#c2b59b;color:#fff" v-b-modal.modal-center class="btn btn-sm ">Modifier</a>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">User information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Nom et Prenom"
                                                        placeholder="Nom et Prenom"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.username"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Email address"
                                                        placeholder="jesse@example.com"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.email"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Mot de passe"
                                                        placeholder="Mot de passe"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.firstName"
                                            />
                                        </div>
                                        
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Contact information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative=""
                                                        label="Adresse"
                                                        placeholder="Adresse"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.address"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Ville"
                                                        placeholder="ville"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.city"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Pays"
                                                        placeholder="Pays"
                                                        input-classes="form-control-alternative"
                                                        v-model="model.country"
                                            />
                                        </div>
                                        
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Description -->
                               
                            </form>
                            <ModalUpdateProfile></ModalUpdateProfile>
                        </template>
                    </card>
                
            
       
    </div>
</template>
<script>
 import ModalUpdateProfile from './ModalUpdateProfile'
  export default {
    name: 'profile',
     components: {
     ModalUpdateProfile
       
    },
    data() {
      return {
        model: {
          username: '',
          email: '',
          firstName: '',
          lastName: '',
          address: '',
          city: '',
          country: '',
          zipCode: '',
          about: '',
        }
      }
    },
  };
</script>
<style></style>
